import React, { useState, useEffect } from 'react'
import DatePicker from "react-datepicker";
import CalendarIcon from "../../../../assets/images/Icons/calendarIcon.svg";
import DownArrow from "../../../../../src/assets/images/Icons/icons/down_arrow.svg";
import UpArrow from "../../../../../src/assets/images/Icons/icons/up_arrow.svg";
import { makeAjax, respStatus, url, showMessage, gameList } from '../../../../helpers/global_helper';
import { useDispatch, useSelector } from "react-redux";
import { setTotalNoResult } from "../../../../redux/actions";
import { formatPrice, formatPricewithdecimal } from "../../../NumberFormat";
import { withTranslation } from "react-i18next";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaCalendar } from "react-icons/fa";


function MemberList(props) {
  const device = useSelector(state => state.CommonConfig.device_type);

  const dispatch = useDispatch()

  const [startDate, setStartDate] = useState(new Date());
  const [selectGameName, setSelectGameName] = useState("0");
  const [memberListData, setMemberListData] = useState([]);
  const [loading, setLoading] = useState(false)
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  // const [gameName, setGameName] = useState([]);
  const [gameName, setGameName] = useState(gameList);
  const marketList = useSelector((state) => state.CommonConfig.marketList);

  const pageNumber = useSelector((state) => state.paginationData.pageNumber)
  const perPage = useSelector((state) => state.paginationData.dataInOnePage)

  const CustomInput = ({ value, onClick }) => (
    <div style={{ position: "relative" }} className="custom_calendar">
      <input
        type="text"
        value={value}
        onClick={onClick} // This opens the calendar on input click
        readOnly // Prevent direct text input
      />
      <button
        onClick={onClick} // This also opens the calendar on icon click

        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        {/* <img src={CalendarIcon} alt="" /> */}
        <FaCalendar />
      </button>
    </div>
  );

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  const sortedData = () => {
    if (sortBy === "date" || sortBy === "joindate") {
      return memberListData.slice().sort((a, b) => {
        const aValue = new Date(a[sortBy]).getTime();
        const bValue = new Date(b[sortBy]).getTime();
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else if (sortBy === "turnover" || sortBy === "commission") {
      return memberListData.slice().sort((a, b) => {
        const aValue = parseFloat(a[sortBy]);
        const bValue = parseFloat(b[sortBy]);
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else if (sortBy) {
      return memberListData.slice().sort((a, b) => {
        const aValue = a[sortBy].toLowerCase();
        const bValue = b[sortBy].toLowerCase();
        return sortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      });
    }
    return memberListData;
  };

  // api for Game list
  // const featchGameList = () => {
  //   makeAjax(url.TOGEL_API.listGame).then((response) => {
  //     if (response.status != respStatus["SUCCESS"]) {
  //       if (response.code != "validation_error") {
  //         showMessage(response);
  //         return;
  //       }
  //       showMessage(response);
  //       return;
  //     }
  //     setGameName(response.data);
  //   });
  // };

  // useEffect(() => {
  //   featchGameList();
  // }, []);

  const handleGameSelectOptions = (e) => {
    const selectedValue = e.target.value;
    setSelectGameName(selectedValue);
  };

  // api for Transaction list
  const fetchEventBonusList = () => {
    setLoading(true)
    let reqData = {
      page: pageNumber,
      length: perPage,
    };
    makeAjax(url.PLAYER_API.listReferral, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code !== "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setMemberListData(response.data.data);
      dispatch(setTotalNoResult(response.data.data.length))
    });
    setLoading(false)
  };

  useEffect(() => {
    fetchEventBonusList();
  }, [perPage, sortBy, sortOrder, pageNumber]);

  return (
    <div className='trasaction_popup'>

      <div className="trasaction_top_bar">
        <div className="calendar">
          <DatePicker
            // showIcon
            customInput={<CustomInput />}
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
            maxDate={new Date()}
          />
        </div>
        <div className="all_game_dropdown">
          <select className="dropdown" onChange={handleGameSelectOptions}>
            <option value="0">All</option>
            {marketList.length > 0 &&
              marketList.map(({ game_id, game_name }) => (
                <option key={game_id} value={game_id}>
                  {game_name}
                </option>
              ))}
          </select>
        </div>
        <div className="search">
          <button  >Search</button>
        </div>

      </div>




      {/* table */}
      <div className={device === "Desktop" ? "informasi_tble_result" : "container"}>
        <table >
          <thead>
            <tr>
              <th onClick={() => handleSort("commission")}>{props.t("no.")}</th>
              <th onClick={() => handleSort("commission")}>
                {props.t("username")}

                <span className="sorting_arrow">
                  {sortBy === "commission" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th onClick={() => handleSort("joindate")}>
                {props.t("register_date")}

                <span className="sorting_arrow">
                  {sortBy === "joindate" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th onClick={() => handleSort("turnover")}>
                {props.t("turnover")}
                <span className="sorting_arrow">
                  {sortBy === "turnover" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th onClick={() => handleSort("commission")}>
                {props.t("commision")}
                <span className="sorting_arrow">
                  {sortBy === "commision" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {!loading &&
              (sortedData().length === 0 ? (
                <tr className="table_data_empty_row ">
                  <td colSpan="5">{props.t("data_not_found")}</td>
                </tr>
              ) :
                (sortedData().map((item, index) => {
                  return (

                    <tr
                      key={index}
                      className={index % 2 === 0 ? "even-row" : "odd-row"}
                    >
                      <td>{index + 1}</td>
                      <td>{item.nickname}</td>
                      <td>
                        <p>{item.joindate}</p>
                      </td>
                      <td>{formatPricewithdecimal(item.turnover)}</td>
                      <td>{formatPricewithdecimal(parseFloat(item.commission).toFixed(2))}</td>
                    </tr>
                  )
                })))
            }
          </tbody>

        </table>
      </div>
    </div>
  )
}

export default withTranslation()(MemberList)
